angular.module('gym.workouts').controller('BulkAddMembersToWorkoutCtrl', ["$scope", "$rootScope", "$modalInstance", "$state", "FeatureNamesService", "Reports", "workout", function($scope, $rootScope, $modalInstance, $state, FeatureNamesService, Reports, workout) {
  $scope.workout = workout;
  $scope.reports = Reports.getList({
    count: 1000
  }).$object;
  $scope.gym = $rootScope.gym;
  $scope.memberPortalLabel = FeatureNamesService.memberPortal();
  $scope.params = {
    workout_id: workout.id,
    show_in_member_portal: workout.show_in_member_portal,
    show_history_in_member_portal: workout.show_history_in_member_portal,
    manageable_by_member: workout.manageable_by_member
  };
  $scope.submit = function() {
    $state.go('gym.workouts.new_bulk_enrol', $scope.params);
    return $modalInstance.close();
  };
  $scope.isReady = function() {
    return $scope.params.report_id;
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
